import { c } from "./createLucideIcon-Bs_bgX_W.js";
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], a = c("loader-circle", e);
export {
  a as L
};
//# sourceMappingURL=loader-circle-CXsMazZi.js.map
